<template>
  <div class="image-bubble-menu" @click.stop>
    <FlotoDropdownPicker
      :allow-clear="false"
      :options="options"
      :value="currDisplay"
      @change="handleDisplayChange"
    >
      <template v-slot:trigger>
        <MTooltip>
          <template v-slot:trigger>
            <MIcon class="cursor-pointer" size="lg" name="image" />
          </template>
          {{ $tc('display') }}
        </MTooltip>
      </template>
    </FlotoDropdownPicker>
    <!-- <image-display-command-button :node="node" :update-attrs="updateAttrs" />

    <edit-image-command-button :node="node" :update-attrs="updateAttrs" />

    <remove-image-command-button :view="view" /> -->
  </div>
</template>

<script>
import { Node as ProsemirrorNode } from 'prosemirror-model'
import { EditorView } from 'prosemirror-view'

export default {
  name: 'ImageBubbleMenu',
  props: {
    node: {
      type: ProsemirrorNode,
      required: true,
    },
    view: {
      type: EditorView,
      required: true,
    },
    updateAttrs: {
      type: Function,
      required: true,
    },
  },
  computed: {
    currDisplay() {
      return this.node.attrs.display
    },
    options() {
      return [
        {
          text: this.$tc('inline'),
          key: 'inline',
        },
        {
          text: this.$tc('left'),
          key: 'left',
        },
        {
          text: this.$tc('right'),
          key: 'right',
        },
        {
          text: this.$tc('break_text'),
          key: 'block',
        },
      ]
    },
  },
  methods: {
    handleDisplayChange(display) {
      this.updateAttrs({ display })
    },
  },
}
</script>
